<div class="row page-header">
    <div class="col-12">
        <h1>Fuel Entry <small>Log the transers of fuels</small></h1>
    </div>
</div>
<div class="container-sm" style="max-width: 800px; padding: 0" [hidden]="isInitialLoading">
    <form class="fuel-form" [hidden]="saved">
        <div class="row fuel-form">
            <div class="col-12">
                <div class="row">
                    <div class="col" [class]="isCollapsed ? 'collapsed-div' : 'full-div'">
                        <ngx-scanner-qrcode
                            #action="scanner"
                            (event)="onScan($event)"
                            [config]="config"
                            (error)="onError($event)"
                        ></ngx-scanner-qrcode>
                    </div>
                </div>
                <div class="row">
                    <div class="col fuel-form">
                        <div class="wj-labeled-input">
                            <wj-auto-complete
                                id="source"
                                [displayMemberPath]="'display'"
                                [itemsSource]="fuelSourceOptions"
                                [selectedValuePath]="'value'"
                                [maxItems]="100"
                                [(selectedValue)]="source"
                                name="source"
                                [isRequired]="false"
                                [isEditable]="false"
                                (selectedIndexChanged)="onSourceChanged()"
                            >
                            </wj-auto-complete>
                            <label for="source">Fuel <b>OUT</b></label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="wj-labeled-input">
                            <wj-auto-complete
                                id="vehicle"
                                [displayMemberPath]="'display'"
                                [itemsSource]="fuelVehicleOptions"
                                [selectedValuePath]="'value'"
                                [maxItems]="100"
                                [(selectedValue)]="vehicle"
                                name="vehicle"
                                [isRequired]="false"
                                [isEditable]="false"
                                (selectedIndexChanged)="onSourceChanged(); onVehicleChanged()"
                            >
                            </wj-auto-complete>
                            <label for="vehicle">Fuel <b>IN</b></label>
                        </div>
                    </div>
                </div>

                @if (lifetimeMeterRequired) {
                    <div class="row">
                        <div class="col">
                            <div class="wj-labeled-input">
                                <wj-input-number
                                    id="lifetimeMeter"
                                    [min]="0"
                                    [isRequired]="true"
                                    [format]="'n1'"
                                    [step]="1"
                                    [(value)]="lifetimeMeter"
                                    (valueChanged)="onLifetimeChanged()"
                                ></wj-input-number>
                                <label for="lifetimeMeter">Lifetime Meter Reading</label>
                            </div>
                        </div>
                    </div>
                }

                @if (!lifetimeMeterIdHidden) {
                    <div class="row">
                        <div class="col">
                            <div class="wj-labeled-input">
                                <wj-input-mask id="lifetimeMeterId" [(ngModel)]="lifetimeMeterId" name="lifetimeMeterId"></wj-input-mask>
                                <label for="lifetimeMeterId">Lifetime Meter Id</label>
                            </div>
                        </div>
                    </div>
                }

                <div class="row">
                    <div class="col">
                        @if (vehicle?.startsWith('TI')) {
                            <h6 style="color: #585858">
                                {{ tranportInversed }} pumped out {{ transportLastFillup | number: '1.1-1' }} gallons since it last fueled
                                up.
                            </h6>
                        }

                        <div class="wj-labeled-input">
                            <wj-input-number
                                id="gallons"
                                [isRequired]="false"
                                [format]="'n1'"
                                [step]="1"
                                [(value)]="gallons"
                                (valueChanged)="validationMessage = ''"
                            ></wj-input-number>
                            @if (fuelCapacity === 0) {
                                <label for="gallons">Gallons</label>
                            }
                            @if (fuelCapacity > 0) {
                                <label for="gallons">Gallons - {{ fuelCapacity }} capacity</label>
                            }
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="wj-labeled-input">
                            <wj-input-number
                                id="meter"
                                [isRequired]="false"
                                [format]="'n0'"
                                [step]="1"
                                [(value)]="meter"
                                (valueChanged)="validationMessage = ''"
                            ></wj-input-number>
                            <label for="meter">Hours</label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="wj-labeled-input">
                            <wj-auto-complete
                                id="job"
                                [displayMemberPath]="'display'"
                                [itemsSource]="jobOptions"
                                [selectedValuePath]="'value'"
                                (selectedIndexChanged)="validationMessage = ''"
                                [(selectedValue)]="job"
                                name="job"
                                [isRequired]="false"
                                [maxItems]="100"
                            >
                            </wj-auto-complete>
                            <label for="job">Job</label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="wj-labeled-input">
                            <wj-input-date-time [(ngModel)]="date" name="date" (valueChanged)="validationMessage = ''"></wj-input-date-time>
                            <label for="date">Date</label>
                        </div>
                    </div>
                </div>
                @if (validationMessage) {
                    <div class="row">
                        <div class="col">
                            <p class="validation">
                                There may be an issue with your entries. Please see the issue below and check that you have the correct
                                vehicles, job, hours, and gallons. You can correct your entries or save the record anyway.
                            </p>
                            <p class="text-danger" style="font-weight: bold">{{ validationMessage }}</p>
                        </div>
                    </div>
                }
                <div class="row" style="margin-bottom: 30px">
                    <div class="col-md-6 col-sm-12" style="margin-bottom: 10px">
                        <button mat-raised-button (click)="reset()">Reset</button>
                    </div>
                    <div class="col-md-6 col-sm-12" style="margin-bottom: 10px">
                        <button
                            mat-raised-button
                            [color]="validationMessage ? 'warn' : 'primary'"
                            [disabled]="!source || !vehicle || !gallons"
                            (click)="save()"
                        >
                            @if (!isSaving && validationMessage && lifetimeMeterRequired && lifetimeMeter === 0) {
                                <span>Add Data</span>
                            }
                            @if (!isSaving && validationMessage && (!lifetimeMeterRequired || lifetimeMeter > 0)) {
                                <span>Save Anyway</span>
                            }
                            @if (isSaving) {
                                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
                            }
                            @if (!isSaving && !validationMessage) {
                                <span>Save</span>
                            }
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    @if (saved) {
        <div class="row fuel-form">
            <div class="col-lg-6 col-md-12 col-sm-12 saved">
                <div style="text-transform: uppercase">The entry has been saved</div>
                <table class="results-table">
                    <tr>
                        <td>Source:</td>
                        <td>{{ source }}</td>
                    </tr>
                    <tr>
                        <td>Vehicle:</td>
                        <td>{{ vehicle }}</td>
                    </tr>
                    <tr>
                        <td>Gallons:</td>
                        <td>{{ gallons }}</td>
                    </tr>
                    <tr>
                        <td>Meter:</td>
                        <td>{{ meter }}</td>
                    </tr>
                    <tr>
                        <td>Job:</td>
                        <td>{{ job }}</td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="row fuel-form">
            <div class="col-lg-6 col-md-12 col-sm-12 saved">
                <button mat-raised-button color="primary" (click)="reset()">Fuel Another</button>
            </div>
        </div>
    }
</div>
